import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { switchMap } from 'rxjs';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { AccountService } from 'app/core';
import { FieldDef } from 'app/core/models';

@Component({
  selector: 'edit-custom-field-select',
  templateUrl: './edit-custom-field-select.component.html',
  styleUrls: ['./edit-custom-field-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditSelectModalComponent extends OnDestroyMixin implements OnInit {
  public updateCustomFieldForm: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FieldDef | any,
    public matDialogRef: MatDialogRef<EditSelectModalComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _accountService: AccountService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.updateCustomFieldForm = this._formBuilder.group({
      related_to_type: [this.data?.related_to_type || 'Project', [Validators.required]],
      label: [this.data?.label || '', [Validators.required]],
      calc_code: [this.data?.meta?.calc_code || ''],
      type: [this.data?.type || '', [Validators.required]],
      options: [this.data?.options || ''],
      readonly: [this.data?.meta?.readonly || false],
      user_editable: [this.data?.meta?.user_editable || false],
      rollup: [this.data?.meta?.rollup || false],
      record_type: [''],
    });
  }

  save(): void {
    this.updateCustomFieldForm.disable();

    if (this.data?.id) {
      const params = {
        id: this.data?.id,
        ...this.updateCustomFieldForm.value,
      };
      this._accountService
        .updateCustomField(params)
        .pipe(untilComponentDestroyed(this))
        .subscribe(() => {
          this.updateCustomFieldForm.enable();
        });
    } else {
      const type = this.updateCustomFieldForm.get('type')?.value;
      const optionsValue = this.updateCustomFieldForm.get('options').value;
      const params = {
        ...this.updateCustomFieldForm.value,
        options: type === 'select' ? (typeof optionsValue === 'string' ? optionsValue.split(',') : optionsValue) : '',
      };
      this._accountService
        .createCustomField(params)
        .pipe(
          untilComponentDestroyed(this),
          switchMap(() => this._accountService.getFieldDefs()),
        )
        .subscribe(() => {
          this.updateCustomFieldForm.enable();
        });
    }
  }

  discard(): void {
    this.matDialogRef.close();
  }

  onDelete(event) {
    let options: any[] = this.data.options;
    let index = options.findIndex((item) => item === event);
    options.splice(index, 1);
    this.data.options = options;
    this.buildForm();
    this.updateCustomFieldForm.markAsDirty();
    this.save();
  }

  onAdd(event) {
    let options: any[] = this.data.options;
    options.push(event.name);
    this.data.options = options;
    this.buildForm();
    this.updateCustomFieldForm.markAsDirty();
    this.save();
  }
}
